function moveVariantPickerToSubscriptionWidget() {
  function onElementAppears() {
    const targetGroup = document.getElementById(
      "paywhirl-one-time-purchase-group"
    );

    const variantsPicker = document.querySelector("variant-selects");

    if (targetGroup && variantsPicker) {
      const variantsPickerStyle = variantsPicker.dataset.styleWithSubsWidget;

      if (variantsPickerStyle == "inside_widget") {
        targetGroup.appendChild(variantsPicker);
      }
    }
  }

  const observer = new MutationObserver((mutations, obs) => {
    const element = document.getElementById("paywhirl-one-time-purchase-group");
    if (element) {
      onElementAppears();
      obs.disconnect();
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
}

document.addEventListener("DOMContentLoaded", () => {
  moveVariantPickerToSubscriptionWidget();
});
